import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/dashboard"); // Get overdue and matured credits for dashboard

export var getOverdueCredits = function getOverdueCredits(params) {
  return getReq("".concat(BASE_URL, "/overdue-credits"), {
    params: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.pageSize) && {
      per_page: params === null || params === void 0 ? void 0 : params.pageSize
    }), (params === null || params === void 0 ? void 0 : params.pageIndex) !== undefined && {
      page: (params === null || params === void 0 ? void 0 : params.pageIndex) + 1
    }), (params === null || params === void 0 ? void 0 : params.franchisee) && {
      franchisee_id: params === null || params === void 0 ? void 0 : params.franchisee
    }), (params === null || params === void 0 ? void 0 : params.office) && {
      office_id: params === null || params === void 0 ? void 0 : params.office
    }), (params === null || params === void 0 ? void 0 : params.daysLate) && {
      days_late: params === null || params === void 0 ? void 0 : params.daysLate
    }), (params === null || params === void 0 ? void 0 : params.sortBy) && {
      sort_by: params === null || params === void 0 ? void 0 : params.sortBy
    }), (params === null || params === void 0 ? void 0 : params.direction) && {
      direction: params === null || params === void 0 ? void 0 : params.direction
    })
  });
}; // Get dashboard summary statistics

export var getDashboardSummary = function getDashboardSummary(params) {
  return getReq("".concat(BASE_URL, "/summary"), {
    params: _objectSpread(_objectSpread({}, (params === null || params === void 0 ? void 0 : params.franchisee_id) && {
      franchisee_id: params.franchisee_id
    }), (params === null || params === void 0 ? void 0 : params.office_id) && {
      office_id: params.office_id
    })
  });
};